import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import AppWrapper from './App'
import { BrowserRouter as Router } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { Analytics } from '@vercel/analytics/react'
import { SpeedInsights } from "@vercel/speed-insights/react"
import * as Sentry from "@sentry/react"
import ErrorBoundary from './context/ErrorBoundary'
import { AuthProvider } from './context/auth'
import { AdminAuthProvider } from './context/adminAuth'
import { ConfigProvider } from 'antd'
import frFR from 'antd/locale/fr_FR'

// Initialize Sentry
Sentry.init({
  dsn: "https://fc40cfec39e772807149881c3748c291@o4508970519560192.ingest.us.sentry.io/4508970525327360",
  integrations: [
    Sentry.browserTracingIntegration()
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    "localhost",
    "falashop.com",
    /^https:\/\/[^/]*\.falashop\.com/,
    "falashop.com",
    /^https:\/\/[^/]*\.falashop\.com/,
  ],
  debug: process.env.NODE_ENV === 'development',
});

// (react-query's QueryClientProvider was removed: nothing in the app used it, and it
// added ~28 KB to every page's first download)
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <AdminAuthProvider>
        <Router>
          <ErrorBoundary>
            <HelmetProvider>
              {/* Ant Design site-wide: Falashop orange instead of its default blue
                  (buttons, tabs, links, focus) and French built-in texts
                  ("Annuler" instead of "Cancel", pagination, empty lists...) */}
              <ConfigProvider locale={frFR} theme={{ token: { colorPrimary: '#E05206', colorLink: '#E05206' } }}>
                <AppWrapper />
              </ConfigProvider>
              <Analytics />
              <SpeedInsights />
            </HelmetProvider>
          </ErrorBoundary>
        </Router>
      </AdminAuthProvider>
    </AuthProvider>
  </StrictMode>,
)

